import { inject, PLATFORM_ID } from "@angular/core";
import { AuthService } from "../app/services/auth.service";
import { CanActivateFn, Router } from "@angular/router";
import { isPlatformBrowser } from "@angular/common";

export const authGuard: CanActivateFn = async (route, state) => {
  const platformId = inject(PLATFORM_ID);

  const authService = inject(AuthService);
  const router = inject(Router);

  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  const isAuthenticated = await authService.isAuthenticated();

  if (isAuthenticated) {
    return true;
  }

  return router.createUrlTree(["/"], {
    queryParams: {
      redirectUrl: state.url,
    },
  });
};
